var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.3333H13.3334L12.3967 10.3967C12.271 10.2709 12.1712 10.1215 12.1031 9.95712C12.0351 9.79275 12.0001 9.61657 12.0001 9.43867V7.33333C12.0002 6.50596 11.7438 5.69889 11.2662 5.02326C10.7887 4.34762 10.1134 3.83664 9.33341 3.56067V3.33333C9.33341 2.97971 9.19294 2.64057 8.94289 2.39052C8.69284 2.14048 8.3537 2 8.00008 2C7.64646 2 7.30732 2.14048 7.05727 2.39052C6.80722 2.64057 6.66675 2.97971 6.66675 3.33333V3.56067C5.11341 4.11 4.00008 5.592 4.00008 7.33333V9.43933C4.00008 9.798 3.85741 10.1427 3.60341 10.3967L2.66675 11.3333H6.00008M10.0001 11.3333V12C10.0001 12.5304 9.78937 13.0391 9.4143 13.4142C9.03922 13.7893 8.53051 14 8.00008 14C7.46965 14 6.96094 13.7893 6.58587 13.4142C6.21079 13.0391 6.00008 12.5304 6.00008 12V11.3333M10.0001 11.3333H6.00008",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutline);
export default __webpack_public_path__ + "static/media/BellOutline.bf5df02073d8fbb587a12d28a815f35a.svg";
export { ForwardRef as ReactComponent };